import {getFunctionUrl} from '@/functions/functionsConfig'

// BACKEND_API
const calendar={
    dummy_auth_token:'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjhmZGVmMzdkLWQ4OGMtNDk0ZS05Nzc3LWI2ZGQxZGM1ZjM5ZCIsImV4cGlyZXNfYXQiOiIyMDIyLTA2LTEwVDEzOjIzOjU5Ljg4MzE1OSJ9.KsSKov6lapRD7qkw6rGvabeMzOUU6yFXJZNKH_Mbvkg',
    // clientId:'713264274646-t6ifofh40otmot798e25sp0a1qhq914n.apps.googleusercontent.com',
    clientId:'123938885377-3eo2j3r5ckho8b146nvpk9kq3errehli.apps.googleusercontent.com',
    redirect_uri:'https://app.looppanel.com/api/oauth/google-oauth-callback',
    // redirect_uri:'https://us-west-2.recall.ai/api/v1/calendar/google_oauth_callback/',
    GOOGLE_OAUTH_PERMISSION_SCOPES : [
        "https://www.googleapis.com/auth/calendar.events.readonly",
        "https://www.googleapis.com/auth/calendar.readonly",
        "https://www.googleapis.com/auth/userinfo.email",
        "https://www.googleapis.com/auth/userinfo.profile",
    ],
    microsoftClientId:'a971edea-f064-4609-9e69-aed220eef2c1',
    microsoft_redirect_uri:'https://app.looppanel.com/api/oauth/microsoft-oauth-callback',
    MICROSOFT_OAUTH_PERMISSION_SCOPES : [
        "offline_access",
        "openid",
        "email",
        "https://graph.microsoft.com/Calendars.Read",
    ],
    Calendar_API_Host:'https://us-west-2.recall.ai',
    API_GetCalendarToken: getFunctionUrl('get_calendar_token'),
    API_GetCalendarUser:"https://us-west-2.recall.ai/api/v1/calendar/user/",
    API_GetCalendarMeetings:"https://us-west-2.recall.ai/api/v1/calendar/meetings/",
    API_UpdateCalendarMeeting:"https://us-west-2.recall.ai/api/v1/calendar/meetings/",
    API_RefreshCalendarMeetings:"https://us-west-2.recall.ai/api/v1/calendar/meetings/refresh/",
    API_RefreshCalendarMeetingsLoop:getFunctionUrl('recall_calendar') + '/refresh-list-meetings',
    API_RetrieveMeetingInformationLoop:getFunctionUrl('recall_calendar') + "/get-calendar-meeting",
    API_UpdateRecordingPreferences:"https://us-west-2.recall.ai/api/v1/calendar/user/",
    API_DisconnectCalendar:"https://us-west-2.recall.ai/api/v1/calendar/user/disconnect/",
    months:['January','February','March','April','May','June','July','August','September','October','November','December'],
    API_GetCalendarMeetingsLoop:getFunctionUrl('recall_calendar') + "/list-meetings",
    API_AddMeetingParticipants: getFunctionUrl('recall_calendar') + '/add-participant',

}

export default calendar;